import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { APP_CONFIG } from '../../config/app-config';
import { buildApiUrl } from '../api-http/form-url-encoded';

@Injectable()
export class CatalogWriterProvider {
  constructor(private http: HttpClient) {}

  save(apiKey: string, locationId: number | string, resource: string,
    logicalId: number | string | null, body: any): Promise<any> {
    if (!apiKey || !String(apiKey).trim()) { return Promise.reject(new Error('La sesión ya no está disponible.')); }
    if (!locationId || !/^[1-9][0-9]*$/.test(String(locationId))) {
      return Promise.reject(new Error('Selecciona una locación válida.'));
    }
    const path = 'catalogo-local/admin/' + resource +
      (logicalId === null || logicalId === undefined ? '' : '/' + encodeURIComponent(String(logicalId))) +
      '?idlocacion=' + encodeURIComponent(String(locationId));
    const options = { headers: new HttpHeaders({ Authorization: apiKey, 'Content-Type': 'application/json' }) };
    const request = logicalId === null || logicalId === undefined ?
      this.http.post<any>(buildApiUrl(APP_CONFIG.apiBaseUrl, path), body, options) :
      this.http.put<any>(buildApiUrl(APP_CONFIG.apiBaseUrl, path), body, options);

    return request.toPromise().then(function (response: any) {
      if (!response || String(response.code) === '1') {
        throw new Error(response && response.message ? response.message : 'No fue posible guardar el catálogo.');
      }
      return response;
    }).catch(function (error: any) {
      if (error instanceof Error) { return Promise.reject(error); }
      if (error && (error.status === 401 || error.status === 403)) {
        return Promise.reject(new Error('No tienes acceso a esta locación.'));
      }
      return Promise.reject(new Error('No fue posible guardar el catálogo.'));
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/catalog-writer/catalog-writer.ts